"use client";

import {
  createAccount,
  hasGithubUsername,
  showLoginError,
  signInWithGoogle,
} from "@/app/database/standard/firebase";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useState } from "react";
import toast from "react-hot-toast";

export default function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const router = useRouter();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const user = await createAccount({ email, password });
      const hasUsername = await hasGithubUsername();

      if (!hasUsername) window.location.href = "/credentials";
      else window.location.href = "/extension/getting-started";
    } catch (error) {
      toast.error(showLoginError(error));
    }
  };

  const handleGoogle = async (e) => {
    e.preventDefault();
    await signInWithGoogle();
  };

  return (
    <section className="relative h-screen flex justify-center items-center">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="">
          <div className="flex flex-col mx-auto text-center mb-6 w-[600px]">
            <h1 className="font-bold text-4xl text-white">
              Create your account
            </h1>
            <h2 className="text-lg text-zinc-400 mt-2">
              Have an account already?{" "}
              <Link className="font-bold text-primary" href="/signin">
                Sign in
              </Link>
            </h2>
          </div>

          {/* Form */}
          <div className="max-w-sm mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-wrap -mx-3 mb-4">
                <div className="w-full px-3">
                  <input
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-input w-full bg-ink-soft border-line text-white placeholder-zinc-500 focus:border-primary focus:ring-primary/30 rounded-xl"
                    placeholder="Email"
                    required
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full px-3">
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="form-input w-full bg-ink-soft border-line text-white placeholder-zinc-500 focus:border-primary focus:ring-primary/30 rounded-xl"
                    placeholder="Password"
                    required
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mt-6">
                <div className="w-full px-3">
                  <button
                    type="submit"
                    className="btn btn-ghost text-white bg-primary hover:bg-secondary w-full rounded-full ring-1 ring-inset ring-white/15"
                  >
                    Sign up
                  </button>
                </div>
              </div>
            </form>
            <div className="divider text-sm text-zinc-500">OR</div>
            <form>
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3">
                  <button
                    onClick={handleGoogle}
                    className="btn btn-ghost px-0 text-gray-800 bg-white hover:bg-gray-100 w-full relative flex rounded-full outline outline-white/15 outline-1 gap-x-6"
                  >
                    <Image
                      className="w-8 absolute left-4"
                      src="/images/general/google-logo.webp"
                      width={100}
                      height={100}
                      alt={"Google logo"}
                    />
                    <span className="ml-8">Sign up With Google</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
